import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import classNames from 'classnames';
import ContributorsFilterContext from './context';
import { Option } from '../common/styles';
import RoundedAvatar from './rounded-avatar';

const Container = styled(Option)`
  margin: 8px 0;
  height: 60px;
  display: flex;
  align-items: center;
  padding: 0 20px 0 10px;
  border-radius: 6px;
  border: ${props => (props.selected ? '1px' : '0px')} solid;
  border-color: ${props => props.theme.secondaryColor};
`;

const Text = styled.span`
  flex-grow: 2;
  margin: 0 18px;
  color: ${props => props.theme.bodyColor};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Checkbox = styled.span`
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  padding: 4px;
  font-size: 12px;
  border: 1px solid ${props => props.theme.secondaryColor};
  border-radius: 2px;
  color: #27ae60;

  &.fa-check {
    color: white;
    background-color: ${props => props.theme.bodyColor};
    border-color: ${props => props.theme.bodyColor};
  }
`;

export default function ContributorOption({
  id, name, profilePictureUrl, selected,
}) {
  const { dispatch } = React.useContext(ContributorsFilterContext);

  const handleClick = e => {
    e && e.preventDefault();
    dispatch({ type: 'toggleSelection', payload: id });
  };

  return (
    <Container selected={selected} onClick={handleClick}>
      <RoundedAvatar {...{ name, profilePictureUrl }} />
      <Text>{name}</Text>
      <Checkbox className={classNames('fa fa-border', { 'fa-check': selected })} />
    </Container>
  );
}

ContributorOption.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  profilePictureUrl: PropTypes.string,
  selected: PropTypes.bool.isRequired,
};

ContributorOption.defaultProps = {
  profilePictureUrl: null,
};
